import { apiClient } from './client';

/** What starting a view-as session returns (MYN-332). */
export interface ViewAsStarted {
  sessionId: string;
  token: string;
  expiresAt: string;
}

/** Start a view-as session for a user; the token opens it in a new tab (FR-240). */
export async function startViewAs(userId: string, reason: string): Promise<ViewAsStarted> {
  const res = await apiClient.post<ViewAsStarted>(`/users/${userId}/view-as-sessions`, { reason });
  return res.data;
}

/** End the view-as session this tab is in (Exit). */
export async function endViewAs(): Promise<void> {
  await apiClient.post('/view-as-sessions/current/end');
}
